import React from 'react';
import styled from 'styled-components';
import partner1 from '../assets/pic1.png';
import partner2 from '../assets/pic2.png';

const PartnersSection = styled.section`
  background-color: white;
  padding: 40px 0;
  
  @media (max-width: 768px) {
    padding: 30px 0;
  }
`;

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const PartnersTitle = styled.p`
  text-align: center;
  margin-bottom: 25px;
  font-size: 1.4rem;
  color: #1a5f7a;
  font-weight: 500;
  
  @media (max-width: 576px) {
    margin-bottom: 20px;
  }
`;

const PartnersLogos = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 50px;
  flex-wrap: wrap;
  
  @media (max-width: 576px) {
    gap: 30px;
  }
`;

const PartnerLogo = styled.img`
  height: ${props => props.height || '100px'};
  object-fit: contain;
  
  @media (max-width: 768px) {
    height: ${props => props.height || '80px'};
  }
  
  @media (max-width: 576px) {
    height: ${props => props.height || '70px'};
  }
`;

const AhmedGroupLogo = styled(PartnerLogo)`
  height: 150px;
  
  @media (max-width: 768px) {
    height: 130px;
  }
  
  @media (max-width: 576px) {
    height: 110px;
  }
`;

const Separator = styled.span`
  font-size: 2rem;
  color: #1a5f7a;
  font-weight: 300;
  
  @media (max-width: 576px) {
    font-size: 1.8rem;
  }
`;

const Partners = () => {
  return (
    <PartnersSection>
      <Container>
        <PartnersTitle>A project of</PartnersTitle>
        <PartnersLogos>
          <AhmedGroupLogo src={partner1} alt="Ahmed Group Logo" />
          <Separator>&amp;</Separator>
          <PartnerLogo src={partner2} alt="D. Watson Logo" />
        </PartnersLogos>
      </Container>
    </PartnersSection>
  );
};

export default Partners; 